import React from 'react';

interface Props {
  width?: string;
  className?: string;
}

const InfoCircleIcon: React.FC<Props> = ({ width, className }) => (
  <svg
    width={width ?? '20'}
    height={width ?? '20'}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M10 18.3346C5.39751 18.3346 1.66667 14.6038 1.66667 10.0013C1.66667 5.3988 5.39751 1.66797 10 1.66797C14.6025 1.66797 18.3333 5.3988 18.3333 10.0013C18.3333 14.6038 14.6025 18.3346 10 18.3346ZM10 16.668C11.7681 16.668 13.4638 15.9656 14.7141 14.7153C15.9643 13.4651 16.6667 11.7694 16.6667 10.0013C16.6667 8.23319 15.9643 6.5375 14.7141 5.28726C13.4638 4.03701 11.7681 3.33464 10 3.33464C8.23189 3.33464 6.5362 4.03701 5.28596 5.28726C4.03572 6.5375 3.33334 8.23319 3.33334 10.0013C3.33334 11.7694 4.03572 13.4651 5.28596 14.7153C6.5362 15.9656 8.23189 16.668 10 16.668ZM9.16667 5.83464H10.8333V7.5013H9.16667V5.83464ZM9.16667 9.16797H10.8333V14.168H9.16667V9.16797Z'
      fill='currentColor'
    />
  </svg>
);

export default InfoCircleIcon;
